function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("clipPath", {
  id: "__lottie_element_149"
}, /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  x: 0,
  y: 0
}));

var _ref3 = /*#__PURE__*/React.createElement("filter", {
  id: "__lottie_element_157",
  filterUnits: "objectBoundingBox",
  x: "0%",
  y: "0%",
  width: "100%",
  height: "100%"
}, /*#__PURE__*/React.createElement("feComponentTransfer", {
  in: "SourceGraphic"
}, /*#__PURE__*/React.createElement("feFuncA", {
  type: "table",
  tableValues: "1.0 0.0"
})));

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  x: 0,
  y: 0,
  fill: "#ffffff",
  opacity: 0
});

var _ref5 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1,0,0,1,0,0.18799999356269836)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4,
  stroke: "rgb(255,0,0)",
  strokeOpacity: 1,
  strokeWidth: 18.2,
  d: " M8,0 C8,0 8,0 8,0 C8,4.415200233459473 4.415200233459473,8 0,8 C-4.415200233459473,8 -8,4.415200233459473 -8,0 C-8,-4.415200233459473 -4.415200233459473,-8 0,-8"
}));

var _ref6 = /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1,0,0,1,0,0.18799999356269836)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4,
  stroke: "rgb(255,255,255)",
  strokeOpacity: 1,
  strokeWidth: 2,
  d: " M0,-7 C3.863300085067749,-7 7,-3.863300085067749 7,0 C7,3.863300085067749 3.863300085067749,7 0,7 C-3.863300085067749,7 -7,3.863300085067749 -7,0 C-7,-3.863300085067749 -3.863300085067749,-7 0,-7z"
}));

var _ref7 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,8,8)",
  opacity: 1
}, /*#__PURE__*/React.createElement("g", {
  opacity: 1,
  transform: "matrix(1,0,0,1,0,0.18799999356269836)"
}, /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  fillOpacity: 0,
  strokeMiterlimit: 4,
  stroke: "rgb(255,255,255)",
  strokeOpacity: 1,
  strokeWidth: 2,
  d: " M0,-7 C3.863300085067749,-7 7,-3.863300085067749 7,0 C7,3.863300085067749 3.863300085067749,7 0,7 C-3.863300085067749,7 -7,3.863300085067749 -7,0 C-7,-3.863300085067749 -3.863300085067749,-7 0,-7z"
})));

var SvgVideoLoading16 = function SvgVideoLoading16(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    width: 16,
    height: 16,
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0px, 0px, 0px)"
    },
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("defs", null, _ref2, _ref3, /*#__PURE__*/React.createElement("mask", {
    id: "__lottie_element_156",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#__lottie_element_157)"
  }, _ref4, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(0.9185875058174133,-0.3952175974845886,0.3952175974845886,0.9185875058174133,8,8)",
    opacity: 1
  }, _ref5)))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#__lottie_element_149)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    transform: "matrix(1,0,0,1,8,8)",
    opacity: 0.4
  }, _ref6), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    },
    mask: "url(#__lottie_element_156)"
  }, _ref7)));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgVideoLoading16, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/videoLoading_16.be47542e.svg";
export { ForwardRef as ReactComponent };